var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-icon-img",
    transform: "translate(4788 5301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-close-img",
    transform: "translate(-5165.997 -5518.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M.352,11.325A1.939,1.939,0,0,1,.6,8.8L3.792,5.963.622,3.213A1.938,1.938,0,0,1,.339.694,1.55,1.55,0,0,1,1.61,0,1.5,1.5,0,0,1,2.6.378L6.046,3.37,9.387.393a1.5,1.5,0,0,1,2.261.282A1.94,1.94,0,0,1,11.4,3.2L8.208,6.038l3.17,2.749a1.939,1.939,0,0,1,.283,2.519A1.551,1.551,0,0,1,10.39,12a1.5,1.5,0,0,1-.986-.377L5.954,8.63,2.613,11.607a1.5,1.5,0,0,1-1,.393A1.548,1.548,0,0,1,.352,11.325Z",
    transform: "translate(380.997 220.882)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 18,
    height: 18,
    transform: "translate(-4788 -5301)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconImg);
export default __webpack_public_path__ + "static/media/close-icon-img.b67066f8e055c9a70ab82cd19ec40aed.svg";
export { ForwardRef as ReactComponent };